import React from 'react'
import PropTypes from 'prop-types'
import { CATEGORIES, categoryLabel } from '../IssueStatuses/constants'
import CategorySummaryCard from './CategorySummaryCard'

const PLACEHOLDER_GROUPS = CATEGORIES.map(({ value }) => ({
  category: value,
  label: categoryLabel(value),
  statuses: [],
  total: 0
}))

const EMPTY_GROUPS = []

const StatsCardsGroup = ({ groups = EMPTY_GROUPS, loading = false }) => {
  const isInitialLoad = loading && groups.length === 0
  const visibleGroups = isInitialLoad ? PLACEHOLDER_GROUPS : groups
  const grandTotal = visibleGroups.reduce((sum, group) => sum + (group.total || 0), 0)
  return (
    <div aria-label="Statistiques par statut" className="tw:flex tw:gap-6" role="group">
      {visibleGroups.map(group => (
        <div key={group.category} className="tw:flex-1 tw:min-w-0">
          <CategorySummaryCard
            category={group.category}
            grandTotal={grandTotal}
            label={group.label}
            statuses={group.statuses}
            total={group.total}
          />
        </div>
      ))}
    </div>
  )
}

StatsCardsGroup.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({
    category: PropTypes.string,
    label: PropTypes.string,
    statuses: PropTypes.arrayOf(PropTypes.shape({
      color: PropTypes.string,
      count: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string
    })),
    total: PropTypes.number
  })),
  loading: PropTypes.bool
}

StatsCardsGroup.defaultProps = {
  groups: [],
  loading: false
}

export default StatsCardsGroup
